import { render, staticRenderFns } from "./IdeaForm.vue?vue&type=template&id=7ab9ec6c&"
import script from "./IdeaForm.vue?vue&type=script&lang=js&"
export * from "./IdeaForm.vue?vue&type=script&lang=js&"
import style0 from "./IdeaForm.vue?vue&type=style&index=0&id=7ab9ec6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports